"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionEvent = void 0;
var SessionEvent;
(function (SessionEvent) {
    SessionEvent["AttributeChanged"] = "attributeChanged";
    SessionEvent["Cancelled"] = "cancelled";
    SessionEvent["Pending"] = "pending";
    SessionEvent["Assigned"] = "assigned";
    SessionEvent["Unassigned"] = "unassigned";
    SessionEvent["Resolved"] = "resolved";
    SessionEvent["AddAnotherExpert"] = "addAnotherExpert";
    SessionEvent["Created"] = "created";
    SessionEvent["Republish"] = "republish";
    SessionEvent["Closed"] = "closed";
    SessionEvent["RepublishForExperts"] = "republishForExperts";
})(SessionEvent = exports.SessionEvent || (exports.SessionEvent = {}));
